export const NAVBAR_HEIGHT = 64
export const NAVBAR_SCROLL_UP_THRESHOLD = 70

export const setNavbarOffset = (visible) => {
  document.documentElement.style.setProperty(
    '--navbar-offset',
    visible ? `${NAVBAR_HEIGHT}px` : '0px'
  )
}
